var map = {
	"./29.mp3": "b4a3",
	"./30.mp3": "ae2e",
	"./31.mp3": "1f3c",
	"./32.mp3": "9c8b",
	"./33.mp3": "5671",
	"./34.mp3": "56d1",
	"./35.mp3": "7837",
	"./36.mp3": "36ae",
	"./37.mp3": "e73c",
	"./38.mp3": "0773",
	"./39.mp3": "72b8",
	"./40.mp3": "4f72",
	"./41.mp3": "1ff6",
	"./42.mp3": "2d4d",
	"./M_Brilliant.mp3": "43e4",
	"./M_Excellent.mp3": "59a1",
	"./M_Fantastic.mp3": "2494",
	"./M_Great.mp3": "33b8",
	"./M_Perfect.mp3": "4f16",
	"./M_Think again.mp3": "5147",
	"./M_Try again.mp3": "dfa7",
	"./M_Very good.mp3": "5bdd",
	"./M_Well done.mp3": "7562",
	"./M_Work harder.mp3": "ea15",
	"./click.mp3": "14d8",
	"./false.mp3": "8825",
	"./true.mp3": "9dab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a418";